var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSpeeding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1973_19964)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.39838 5.94491C7.70036 4.91308 9.29666 4.23336 11.043 4.04995V6.69369H13.043V4.05939C17.1961 4.53554 20.4819 7.82087 20.9442 11.9531H18.3047V13.9531H20.9441C20.7506 15.6664 20.0644 17.2326 19.0283 18.5175L16.8805 16.3792L15.4695 17.7965L18.3611 20.6755C18.7513 21.0639 19.382 21.0639 19.7722 20.6755C21.7581 18.6983 23 15.975 23 12.9561C23 6.89891 18.0731 2 12 2C5.92633 2 1 6.89946 1 12.9644C1 16.0025 2.2606 18.7343 4.25442 20.7103C4.64484 21.0972 5.27435 21.0965 5.66388 20.7087L8.58888 17.7965L7.17778 16.3792L4.99471 18.5527C3.94655 17.2613 3.24933 15.6827 3.05516 13.9531H5.7513V11.9531H3.05651C3.25115 10.2227 3.93941 8.64172 4.97819 7.35318L6.74271 9.10995L8.15381 7.69263L6.39838 5.94491ZM12.7103 13.6611L17.7103 8.68306L16.293 7.27196L11.293 12.25L12.7103 13.6611Z",
    fill: "#CCCFD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1973_19964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpeeding);
export default __webpack_public_path__ + "static/media/icon-speeding.a95468dd1f25760346392836b2a23c81.svg";
export { ForwardRef as ReactComponent };